import { createContext } from "react";

const authContext = createContext({
  authenticated:null,
  setAuthenticated: (auth) => {},
});

export default authContext;
